import { useState, useEffect } from "react";

export default function FloatingContact() {
  const [showTop, setShowTop] = useState(false);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    const handleScroll = () => setShowTop(window.scrollY > 400);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      {/* Floating contact group - bottom right */}
      <div className="fixed bottom-6 right-4 md:right-6 z-50 flex flex-col items-end gap-3">

        {/* Back to top */}
        {showTop && (
          <button
            onClick={scrollToTop}
            className="w-10 h-10 flex items-center justify-center bg-white border border-gray-200 text-gray-500 rounded-full hover:bg-gray-50 hover:text-[#0E5C3A] transition-all cursor-pointer animate-fade-in"
            title="Lên đầu trang"
          >
            <i className="ri-arrow-up-line text-base"></i>
          </button>
        )}

        {/* Expanded sub-actions */}
        {expanded && (
          <div className="flex flex-col items-end gap-2.5 animate-fade-in">
            {/* Zalo */}
            <div className="flex items-center gap-2">
              <span className="bg-white text-gray-700 text-xs font-medium px-3 py-1.5 rounded-full shadow-sm whitespace-nowrap">
                Chat Zalo
              </span>
              <a
                href="https://zalo.me/0914410174"
                target="_blank"
                rel="noopener noreferrer"
                className="w-12 h-12 flex items-center justify-center bg-[#0068FF] text-white rounded-full hover:bg-[#0055CC] transition-all cursor-pointer"
                title="Zalo"
              >
                <i className="ri-message-2-line text-lg"></i>
              </a>
            </div>

            {/* Email */}
            <div className="flex items-center gap-2">
              <span className="bg-white text-gray-700 text-xs font-medium px-3 py-1.5 rounded-full shadow-sm whitespace-nowrap">
                Gửi Email
              </span>
              <a
                href="mailto:thuanphatkt.company@gmail.com"
                className="w-12 h-12 flex items-center justify-center bg-[#D4A017] text-white rounded-full hover:bg-[#B8891A] transition-all cursor-pointer"
                title="Email"
              >
                <i className="ri-mail-line text-lg"></i>
              </a>
            </div>

            {/* Phone */}
            <div className="flex items-center gap-2">
              <span className="bg-white text-gray-700 text-xs font-medium px-3 py-1.5 rounded-full shadow-sm whitespace-nowrap">
                0236.651.7174
              </span>
              <a
                href="tel:02366517174"
                className="w-12 h-12 flex items-center justify-center bg-[#0E5C3A] text-white rounded-full hover:bg-[#0A4A2E] transition-all cursor-pointer"
                title="Gọi điện"
              >
                <i className="ri-phone-line text-lg"></i>
              </a>
            </div>
          </div>
        )}

        {/* Main toggle button */}
        <button
          onClick={() => setExpanded(!expanded)}
          className={`w-14 h-14 flex items-center justify-center rounded-full text-white transition-all duration-300 cursor-pointer ${
            expanded
              ? "bg-gray-500 hover:bg-gray-600 rotate-45"
              : "bg-[#0E5C3A] hover:bg-[#0A4A2E]"
          }`}
          title={expanded ? "Đóng" : "Liên hệ ngay"}
        >
          {expanded ? (
            <i className="ri-close-line text-xl"></i>
          ) : (
            <i className="ri-phone-fill text-xl"></i>
          )}
        </button>

        {/* Pulse ring animation on main button when not expanded */}
        {!expanded && (
          <span className="absolute bottom-0 right-0 w-14 h-14 rounded-full bg-[#0E5C3A]/40 animate-ping pointer-events-none"></span>
        )}
      </div>
    </>
  );
}
